import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PartnerResources from './features/PartnerResources/PartnerResources';
import Dashboard from './features/Dashboard/Dashboard';
import QuestionnairesRedirect from './features/Questionnaires/QuestionnairesRedirect';
import Assessments from './features/Assessments/Assessments';
import Reporting from './features/Reporting/Reporting';
import CssBaseline from '@mui/material/CssBaseline';
import LoginPage from './features/Forms/LoginPage';
import SsoLoginPage from './features/Forms/SsoLoginPage';
import ProtectedRoute from './features/Navigation/ProtectedRoute';
import OnboardForm from './features/Vendors/Onboarding/OnboardingForm';
import PageNotFound from './features/Helpers/PageNotFound';
import Profile from './features/Vendors/Profile';
import OnBoarding from './features/Vendors/Onboarding/OnBoarding';
import CompanyOnBoardingForm from './features/Vendors/Onboarding/CompanyOnBoardingForm';
import OnBoardingQuestionnaire from './features/Vendors/Onboarding/Questionnaire';
import PaymentWorkFlow from './features/Vendors/Onboarding/PaymentWorkFlow';
import AdminTabs from './features/Admin/AdminTabs';
import AssessmentQCReviewPage from './features/Admin/QC/AssessmentQCReviewPage';
import Directory from './features/Directory/Directory';
import CompanyDirectory from './features/Directory/CompanyDirectory';
import CompanyDetail from './features/Directory/CompanyDetail';
import UserProfile from './features/Users/UserProfile';
import Survey from './features/Surveys/Survey';
import Assessment from './features/Assessments/Assessment';
import WaitingForApproval from './features/Users/WaitingForApproval';
import ApplicationDirectory from './features/Applications/Applications';
import { useAppSelector } from './app/hooks';
import SharedReports from './features/SharedReports/SharedReports';
import { USER_TYPES } from './services/user';
import useGlobalAuthSession from './hooks/useGlobalAuthSession';
import { ProfileVersionLayer } from './features/Vendors/profileVersion';

function App() {
  const { user } = useAppSelector(state => state.user);
  useGlobalAuthSession();

  return (
    <div>
      <CssBaseline />
      <Routes>
        <Route index element={<LoginPage />} />
        <Route path="admin-sso-login" element={<SsoLoginPage />} />
        <Route path="sign-up" element={ <OnboardForm />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<ProfileVersionLayer />}>
          <Route path="waiting-for-approval" element={<WaitingForApproval />} />
          <Route path="company-onboarding" element={<OnBoarding />} >
            <Route path="" element={<CompanyOnBoardingForm /> } />
            <Route path="questionnaire" element={<OnBoardingQuestionnaire />} />
            <Route path="payments" element={<PaymentWorkFlow />} />
          </Route>
          {(user?.type === USER_TYPES.TPN_ADMIN || user?.type === USER_TYPES.CONTENT_OWNER) && <Route path="dashboard" element={<Dashboard />} />}
          <Route path="partner-resources" element={<PartnerResources />} />
          <Route path="partner-resources/:resourceSection" element={<PartnerResources />} />
          <Route path="partner-resources/:resourceSection/:documentId" element={<PartnerResources />} />
          <Route path="trusted-partner-exchange" element={<SharedReports />} />
          <Route path="profile" element={<Profile />} />
          <Route path="profile/:profileSection" element={<Profile />} />
          <Route path="user-profile" element={<UserProfile />} />
          <Route path="registry" element={<Directory/>} >
            <Route path="" element={<CompanyDirectory />} />
            {(user?.type === USER_TYPES.TPN_ADMIN || user?.type === USER_TYPES.CONTENT_OWNER) && <Route path=":companyId" element={<CompanyDetail />} />}
            {(user?.type === USER_TYPES.TPN_ADMIN || user?.type === USER_TYPES.CONTENT_OWNER) && <Route path=":companyId/:profileSection" element={<CompanyDetail />} />}
          </Route>
          {user?.type === USER_TYPES.TPN_ADMIN && (
            <>
            <Route path="admin" element={<AdminTabs />} />
            <Route path="admin/:tab/*" element={<AdminTabs />} />
            <Route path="admin/assessment-qc/:workflowId" element={<AssessmentQCReviewPage />} />
            </>
          )}
          <Route path="applications" element={<ApplicationDirectory />} />
          <Route path="questionnaire/:surveyId" element={<Survey />} />
          <Route path="questionnaire/:surveyId/?question=:questionId" element={<Survey />} />
          <Route path="questionnaires/*" element={<QuestionnairesRedirect />} />
          <Route path="assessments" element={<Assessments />} />
          <Route path="assessment/:assessmentId/questionnaire/:surveyId" element={<Assessment />} />
          <Route path="assessment/:assessmentId/questionnaire/:surveyId/?question=:questionId" element={<Assessment />} />
          {user?.type === USER_TYPES.TPN_ADMIN && <Route path="reporting" element={<Reporting />} />}
          </Route>
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
}

export default App;
